import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConstants } from '../common/constants';
import { ReportUser } from '../models/db/report-user';
import { ReportUsersResponse } from '../models/responses/report-users.response';
import { IResponse, BaseResponse } from '../models/responses';

@Injectable({
  providedIn: 'root'
})
export class ReportUserService {

  constructor(private httpClient: HttpClient) { }

  Get(): Observable<ReportUsersResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/ReportUser/GetReportUsers`;

    return this.httpClient.get<ReportUsersResponse>(url, { headers });
  }

  GetById(_id: number): Observable<IResponse<ReportUser>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/ReportUser/GetReportUserById?id=${_id}`;

    return this.httpClient.get<IResponse<ReportUser>>(url, { headers });
  }

  Store(_reportUser: ReportUser): Observable<BaseResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/ReportUser/StoreReportUser`;

    return this.httpClient.post<BaseResponse>(url, _reportUser, { headers });
  }
}
